// extracted by mini-css-extract-plugin
export default {"formSection":"FormSection_formSection__Ujsq5","sectionContainer":"FormSection_sectionContainer__q3lpw","shade":"FormSection_shade__XP-JF"};